import { AxiosError } from 'axios';
import { ErrorResponse, globalError, globalErrorResponse } from '../../../shared/notification/actions';
import { NotificationState } from '../../../app-store/notification/notificationReducer';
import { NavigateFunction } from 'react-router-dom';
import { TFunction } from 'i18next';

const isAxiosError = (error: any): error is AxiosError => {
    return error.hasOwnProperty('response');
};

export function typedFailure(
    error: ErrorResponse,
    route: string,
    showNotificationWithInfo: (info: NotificationState) => void,
    navigate: NavigateFunction,
    t: TFunction
) {
    if (!isAxiosError(error)) {
        return globalErrorResponse(error);
    }

    const errorData = error.response?.data as { errorCode: string; message: string | null };

    switch (error.response?.status) {
        case 403:
            if (errorData.errorCode === 'outdatedShoppingCartVersion') {
                showNotificationWithInfo({
                    title: null,
                    message: errorData.message,
                    dataDisplay: null,
                    dataRaw: null,
                    callback: () => window.location.reload(),
                    showCancel: true,
                    submitLabel: 'Reload'
                });
            } else if (errorData.errorCode === 'invalidProductFormatForCustomer') {
                showNotificationWithInfo({
                    title: null,
                    message: errorData.message,
                    dataDisplay: null,
                    dataRaw: null,
                    callback: () => navigate(route)
                });
            } else if (
                errorData.errorCode === 'invalidProductFormatForAccount' ||
                errorData.errorCode === 'orderContainsEmagazineAlongWithOtherLoanFormat'
            ) {
                showNotificationWithInfo({ title: null, message: errorData.message });
            } else {
                globalError(error);
            }
            break;

        case 409:
            if (errorData.errorCode === 'withdrawnProducts') {
                showNotificationWithInfo({
                    title: t('notifications.unavailableProducts.title'),
                    message: t('notifications.unavailableProducts.message'),
                    dataDisplay: null,
                    dataRaw: null,
                    callback: () => navigate(route)
                });
            } else {
                globalErrorResponse(error);
                navigate(route);
            }
            break;

        default:
            globalErrorResponse(error);
    }
}
